"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require("../index");

var _SelectListItem = require("./SelectListItem");

var _SelectListItem2 = _interopRequireDefault(_SelectListItem);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectOption = function (_PureComponent) {
  _inherits(SelectOption, _PureComponent);

  function SelectOption(props) {
    _classCallCheck(this, SelectOption);

    return _possibleConstructorReturn(this, (SelectOption.__proto__ || Object.getPrototypeOf(SelectOption)).call(this, props));
  }

  _createClass(SelectOption, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          multiple = _props.multiple,
          value = _props.value,
          isActive = _props.isActive,
          selectedDisplay = _props.selectedDisplay,
          searchableText = _props.searchableText,
          showAddButton = _props.showAddButton,
          disabled = _props.disabled,
          disabledForTags = _props.disabledForTags,
          tagStyle = _props.tagStyle,
          tagHeader = _props.tagHeader,
          tagText = _props.tagText,
          keyboardHighlight = _props.keyboardHighlight,
          others = _objectWithoutProperties(_props, ["children", "multiple", "value", "isActive", "selectedDisplay", "searchableText", "showAddButton", "disabled", "disabledForTags", "tagStyle", "tagHeader", "tagText", "keyboardHighlight"]);

      var content = multiple && !showAddButton && !disabledForTags ? _react2.default.createElement(
        _index.NoClickOutsideCheckbox,
        { switchTabIndex: -1, checked: isActive, disabled: disabled },
        children
      ) : children;

      var addClass = (0, _classnames2.default)("a-select-list-add-button", {
        isActive: isActive
      });
      var addButton = showAddButton && _react2.default.createElement(
        "div",
        { className: addClass },
        isActive ? "ADDED" : "ADD"
      );

      return _react2.default.createElement(
        _SelectListItem2.default,
        Object.assign({
          value: value,
          active: isActive,
          disabled: disabled,
          disabledForTags: disabledForTags,
          showAddButton: showAddButton,
          keyboardHighlight: keyboardHighlight
        }, others),
        content,
        addButton
      );
    }
  }]);

  return SelectOption;
}(_react.PureComponent);

SelectOption.defaultProps = {
  showAddButton: false,
  disabled: false,
  disabledForTags: false
};


SelectOption.propTypes = {
  isActive: _propTypes2.default.bool,
  value: _propTypes2.default.any,
  children: _propTypes2.default.any,
  selectedDisplay: _propTypes2.default.any,
  disabled: _propTypes2.default.bool,
  // internal prop
  disabledForTags: _propTypes2.default.bool,

  // when true, add ui and different effect
  // only clickable in add button
  showAddButton: _propTypes2.default.bool,

  //read by select
  searchableText: _propTypes2.default.string,

  tagStyle: _propTypes2.default.object,
  tagHeader: _propTypes2.default.any,
  tagText: _propTypes2.default.any,

  keyboardHighlight: _propTypes2.default.bool
};

SelectOption.displayName = "SelectOption";

exports.default = SelectOption;